var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictogramPostOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "62px",
    viewBox: "0 0 53 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#ffffff",
    x: 2.21,
    y: 9.54,
    width: 35.11,
    height: 51.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "brandable",
    fill: "#0884FD",
    opacity: 0.3,
    x: 17.44,
    y: 24.01,
    width: 35.03,
    height: 23.49
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#ffffff",
    x: 9.61,
    y: 14.83,
    width: 19.32,
    height: 6.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "brandable",
    id: "Rectangle",
    fill: "#231F20",
    x: 34.78,
    y: 50.04,
    width: 1.7,
    height: 3.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M3.05,53.93 L3.05,10.59 L0.05,7.59 L0.05,3.83 L0.47,3.62 C0.72,3.49 6.82,0.54 19.78,0.54 C32.74,0.54 38.84,3.54 39.09,3.62 L39.51,3.83 L39.51,7.6 L36.51,10.6 L36.51,22 L35,22 L35,11 L4.56,11 L4.56,46.43 L14.42,46.43 L14.42,47.94 L4.56,47.94 L4.56,53.94 L3.05,53.93 Z M2.05,7.46 L4.12,9.52 L35.44,9.52 L37.51,7.46 L37.34,7.05 L25,7.05 L25,5.53 L38,5.53 L38,4.79 L37.85,4.73 C36.27,4.1 30.31,2.06 19.79,2.06 C9.27,2.06 3.31,4.06 1.73,4.73 L1.58,4.79 L1.58,5.53 L14.58,5.53 L14.58,7.05 L2.22,7.05 L2.05,7.46 Z",
    id: "Shape",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M1.54,61.48 L1.54,55.41 L38,55.41 L38,61.48 L1.54,61.48 Z M3.05,59.77 L36.48,59.77 L36.48,57.11 L3.05,57.11 L3.05,59.77 Z",
    id: "Shape",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M9.78,21.54 L9.78,14.47 L28.78,14.47 L28.78,21.54 L9.78,21.54 Z M11.25,20.13 L27.25,20.13 L27.25,15.88 L11.25,15.88 L11.25,20.13 Z",
    id: "Shape",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "brandable",
    d: "M17.5,47.38 L17.5,24.2 L52.59,24.2 L52.59,47.38 L17.5,47.38 Z M20.5,45.48 L20.67,45.89 L49.46,45.89 L49.63,45.48 L42.63,38.54 L43.63,37.54 L50.63,44.48 L51.04,44.31 L51.04,27.33 L50.63,27.16 L42.32,35.5 C38.2994828,39.5114794 31.7905172,39.5114794 27.77,35.5 L19.41,27.16 L19,27.33 L19,44.26 L19.41,44.43 L26.41,37.49 L27.46,38.49 L20.5,45.48 Z M20.5,26.1 L28.86,34.45 C32.2983089,37.8777244 37.8616911,37.8777244 41.3,34.45 L49.66,26.1 L49.49,25.69 L20.64,25.69 L20.5,26.1 Z",
    id: "Shape",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPostOffice);
export default __webpack_public_path__ + "static/media/pictogram-post-office.8a9261da4633e694a2191705e9f7e2f6.svg";
export { ForwardRef as ReactComponent };